import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, UtensilsCrossed } from 'lucide-react';
import { restaurantInfo, openingHours, kitchenHours, navLinks } from '../data/mock';
import BullLogo from './BullLogo';

const Footer = () => {
  return (
    <footer className="bg-[#1a0a0a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-0 mb-5">
              <BullLogo size={50} />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed">
              {restaurantInfo.description}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-brand text-lg mb-5 text-amber-400">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/50 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-brand text-lg mb-5 text-amber-400">
              Kontakt
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-amber-400/70 mt-0.5 shrink-0" />
                <span className="text-white/50 text-sm">{restaurantInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-amber-400/70 mt-0.5 shrink-0" />
                <span className="text-white/50 text-sm">{restaurantInfo.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-amber-400/70 mt-0.5 shrink-0" />
                <span className="text-white/50 text-sm">{restaurantInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-brand text-lg mb-5 text-amber-400">
              Öffnungszeiten
            </h4>
            <ul className="space-y-2">
              {openingHours.map((item) => (
                <li key={item.day} className="flex justify-between text-sm">
                  <span className="text-white/50">{item.day}</span>
                  <span className={`${
                    item.hours === 'Ruhetag' ? 'text-red-400/70' : 'text-white/70'
                  }`}>
                    {item.hours}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-3 pt-3 border-t border-white/[0.06]">
              <div className="flex items-center gap-2">
                <UtensilsCrossed size={12} className="text-amber-400/70" />
                <span className="text-white/50 text-xs">{kitchenHours}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} La Bodega Borkum. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-white/30 hover:text-white/60 text-xs transition-colors">
              Datenschutz
            </Link>
            <Link to="/" className="text-white/30 hover:text-white/60 text-xs transition-colors">
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
